(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-card-swipe')) {
    class VariantCardSwipe extends HTMLElement {
      connectedCallback() {
        const generation = (this.generation || 0) + 1;
        this.generation = generation;
        customElements.whenDefined('product-block').then(() => {
          if (this.isConnected && this.generation === generation) this.connect();
        });
      }

      connect() {
        if (this.card) return;
        const card = this.closest('product-block[data-variant-swipe]');
        if (!card) return;
        const images = Array.from(card.querySelectorAll('.product-block__image'))
          .filter((image) => image.closest('product-block') === card);
        if (!images.length) return;
        this.card = card;
        this.images = images;
        this.events = new AbortController();
        this.originalIncrement = card.incrementActiveImage;
        this.originalSetActive = card.setActiveImage;
        this.mediaOption = card.querySelector('.product-block-options--swatch')
          || card.querySelector('.product-block-options[data-option-name]');
        this.dots = card.querySelector('.product-block__image-dots');

        const starts = new Set((card.dataset.variantMediaStarts || '').split(',').filter(Boolean));
        card.querySelectorAll('.product-block-options__item[data-media]').forEach((swatch) => {
          if (swatch.closest('product-block') === card) starts.add(swatch.dataset.media);
        });
        let group = '';
        this.items = images.map((image) => {
          const id = image.dataset.mediaId;
          if (starts.has(id)) group = id;
          return {
            image,
            id,
            group: card.dataset.variantDefaultOnly === 'true' ? 'all' : (group || `single-${id}`)
          };
        });

        card.incrementActiveImage = (increment) => {
          if (card.dataset.variantSwiping === 'false' || this.allowed.length < 2) return;
          const next = (this.index + increment + this.allowed.length) % this.allowed.length;
          this.show(next);
        };
        card.setActiveImage = (index) => {
          const source = card.images || this.images;
          const candidate = source[(index % source.length + source.length) % source.length];
          const localIndex = this.allowed.findIndex((item) => item.image === candidate);
          if (localIndex !== -1) this.show(localIndex);
        };

        const select = (event) => {
          if (!(event.target instanceof Element)) return;
          const swatch = event.target.closest('.product-block-options__item');
          if (!swatch || swatch.closest('product-block') !== card) return;
          if (swatch.closest('.product-block-options') !== this.mediaOption) return;
          if (event.type === 'mouseenter' && event.target !== swatch) return;
          this.selectMedia(swatch.dataset.media || '');
          this.updateLinks(swatch);
        };
        const options = { capture: true, signal: this.events.signal };
        card.addEventListener('mouseenter', select, options);
        card.addEventListener('click', select, options);
        card.addEventListener('keydown', (event) => {
          const swatch = event.target.closest('.product-block-options__item');
          if (!swatch || swatch.closest('.product-block-options') !== this.mediaOption) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            swatch.click();
          }
        }, options);

        this.mediaOption?.querySelectorAll('.product-block-options__item').forEach((swatch) => {
          swatch.setAttribute('role', 'button');
          swatch.setAttribute('tabindex', '0');
          swatch.setAttribute('aria-label', swatch.dataset.optionItem || swatch.textContent.trim());
        });
        this.selectMedia(card.dataset.variantInitialMedia ?? images[0].dataset.mediaId);
        card.setAttribute('data-variant-ready', '');
      }

      updateLinks(swatch) {
        const name = this.mediaOption?.dataset.optionName;
        const value = swatch.dataset.optionItem;
        if (!name || value == null) return;
        this.card.querySelectorAll('.product-link, .quickbuy-toggle').forEach((link) => {
          if (link.closest('product-block') !== this.card) return;
          const url = new URL(link.getAttribute('href'), window.location.href);
          url.searchParams.delete('variant');
          url.searchParams.delete('option_values');
          url.searchParams.set(name, value);
          link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          link.setAttribute('rel', 'nofollow');
        });
      }

      selectMedia(id) {
        const selected = this.items.find((item) => item.id === String(id));
        this.allowed = selected ? this.items.filter((item) => item.group === selected.group) : [];
        this.card.dataset.variantCount = String(this.allowed.length);
        this.items.forEach((item) => {
          item.image.toggleAttribute('data-variant-excluded', !this.allowed.includes(item));
        });
        if (this.dots) {
          this.dots.replaceChildren(...this.allowed.map(() => {
            const dot = document.createElement('div');
            dot.className = 'product-block__image-dot';
            return dot;
          }));
        }
        this.mediaOption?.querySelectorAll('.product-block-options__item').forEach((swatch) => {
          const item = this.items.find((candidate) => candidate.id === swatch.dataset.media);
          const active = selected ? item?.group === selected.group : !swatch.dataset.media;
          swatch.setAttribute('aria-pressed', String(Boolean(active)));
        });
        this.show(Math.max(0, this.allowed.indexOf(selected)));
      }

      show(index) {
        this.index = index;
        const active = this.allowed[index]?.image;
        const hover = this.allowed[(index + 1) % this.allowed.length]?.image;
        this.images.forEach((image) => {
          image.classList.toggle('product-block__image--active', image === active);
          image.classList.toggle('product-block__image--show-on-hover', image === (hover || this.images[0]));
          if (image === active || image === hover) {
            image.classList.remove('product-block__image--inactivated');
            if (window.theme && typeof window.theme.manuallyLoadImages === 'function') {
              window.theme.manuallyLoadImages(image);
            }
          }
        });
        this.dots?.querySelectorAll('.product-block__image-dot').forEach((dot, dotIndex) => {
          dot.classList.toggle('product-block__image-dot--active', dotIndex === index);
        });
      }

      disconnectedCallback() {
        this.generation = (this.generation || 0) + 1;
        this.events?.abort();
        if (this.card) {
          this.card.incrementActiveImage = this.originalIncrement;
          this.card.setActiveImage = this.originalSetActive;
          this.card = null;
        }
      }
    }
    customElements.define('variant-card-swipe', VariantCardSwipe);
  }
  } catch(e) { console.error(e); }
})();

})();
